import { render } from "./SimpleTab.vue?vue&type=template&id=7a8d252e"
import script from "./SimpleTab.vue?vue&type=script&lang=js"
export * from "./SimpleTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__